import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, isRef as _isRef, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'AppNavigator',
  setup(__props) {


const { ui, queryModel, navigatorItems, queryAlgolia, execute } = useNavigator()


return (_ctx: any,_cache: any) => {
  const _component_hy_icon = _resolveComponent("hy-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_hy_dialog = _resolveComponent("hy-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_btn, {
      icon: "",
      color: "white",
      variant: "text",
      "aria-label": "Open navigator",
      onClick: _unref(ui).navigator.open
    }, {
      default: _withCtx(() => [
        _createVNode(_component_hy_icon, {
          name: "Map",
          color: "white"
        })
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_hy_dialog, {
      modelValue: _unref(ui).navigator,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(ui).navigator) = $event)),
      title: "Navigator"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_autocomplete, {
          modelValue: _unref(queryModel),
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => (_isRef(queryModel) ? (queryModel).value = $event : null)),
            _unref(execute)
          ],
          items: _unref(navigatorItems),
          placeholder: "Find a page...",
          "item-title": "name",
          "item-value": "route",
          variant: "solo",
          "menu-props": { offset: 10 },
          color: "#295fd2",
          autofocus: "",
          "auto-select-first": "",
          "return-object": "",
          "onUpdate:search": _unref(queryAlgolia),
          class: "hy-search"
        }, {
          item: _withCtx(({ props, item }) => [
            _createVNode(_component_v_list_item, _mergeProps(props, {
              subtitle: item.raw['type'],
              title: item.raw['name']
            }), {
              prepend: _withCtx(() => [
                (item.raw['icon'])
                  ? (_openBlock(), _createBlock(_component_hy_icon, {
                      key: 0,
                      name: item.raw['icon']
                    }, null, 8, ["name"]))
                  : _createCommentVNode("", true),
                (item.raw['image'])
                  ? (_openBlock(), _createBlock(_component_v_avatar, {
                      key: 1,
                      image: item.raw['image']
                    }, null, 8, ["image"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1040, ["subtitle", "title"])
          ]),
          "append-inner": _withCtx(() => [
            _createVNode(_component_hy_icon, {
              name: "Map",
              color: "primary",
              small: ""
            })
          ]),
          _: 1
        }, 8, ["modelValue", "items", "onUpdate:search", "onUpdate:modelValue"]),
        _cache[2] || (_cache[2] = _createElementVNode("p", null, "Use the navigator to quickly move between pages in Studio.", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("ul", { class: "text-caption ml-4 mt-2" }, [
          _createElementVNode("li", null, "Type a page name to search for matches."),
          _createElementVNode("li", null, "You can add pages to your Favorites to give them priority.")
        ], -1))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})